// `import.meta.env` is a Vite-only binding. Optional chaining lets Node (and any
// other plain-ESM loader, e.g. Playwright's TS runner) load this module without
// throwing; the `?? 'test'` fallback makes downstream env-keyed lookups
// (commonGlobals[ENV], DOMAIN[ENV], …) deterministic outside Vite. Vite
// substitutes the access at build time, so the fallback is dead code in
// browser/SSR bundles.
export const ENV = ((import.meta as { env?: { ODFE_ENV?: string } }).env?.ODFE_ENV ?? 'test') as
  | 'development'
  | 'test'
  | 'qa'
  | 'staging'
  | 'production';

export const IS_PROD = ENV === 'production';
export const IS_DEV = ENV === 'development';
export const IS_TEST = ENV === 'test';
